export default __webpack_public_path__ + "static/offzname-logo-removebg-preview-73c3aa0b84a9c73ca595173821560820.png";